/**
 * Carousel for selfie pictures.
 **/
app.add({

    Carousel2: function(node){
        this.current = 0;
        this.paused = false;
        var carousel = this;

        this.items = $(node).find('.carousel2-item');
        this.length = this.items.length;
        $(node).find('.prev')[0].addEventListener('click', this);
        $(node).find('.next')[0].addEventListener('click', this);
        window.addEventListener('load', this);

        this.initial();
        this.timeout = null;
        this.setTimeout();

        var coords;
        var getMouseCoordinates = function (e) {
            return {
                x: e.clientX,
                y: e.clientY
            };
        };

        document.addEventListener('mousemove', function (e) {
            coords = getMouseCoordinates(e);
            var divCoords = $('.carousel2-item:visible').get(0).getBoundingClientRect();

            if (coords.x >= divCoords.left && coords.x <= divCoords.right && coords.y >= divCoords.top && coords.y <= divCoords.bottom) {
                carousel.pause();
            } else {
                carousel.resume();
            }
        }, false);
    },

    Carousel2Prototype: {
        handleEvent: function(e){
            var method = e.target.className;
            if (method === 'icon-next') method = 'next';
            if (method === 'icon-prev') method = 'prev';
            if (! this[method]) return;
            this[method](e);
        },
        initial: function(){
          var $el = this.items.filter(':visible');
          $($el.hide().get(0)).show();
        },
        pause: function(){
          if (! this.paused) {
            this.paused = true;
            this.clearTimeout();
          }
        },
        resume: function(){
          if (this.paused) {
            this.paused = false;
            this.setTimeout();
          }
        },
        next: function(){
            if (this.current < this.length - 1) {
              this.move(+1);
            } else {
              this.current = 0;
              this.move(0);
            }
            this.setTimeout();
        },
        prev: function(){
            if (this.current) {
                this.move(-1);
            }
        },
        move: function(d){
          this.current += d;
          var $next = $(this.items.get(this.current));
          var carousel = this;

          var $el = this.items.filter(':visible');
          this.hide($el, function(){
            carousel.show($next, function(){
              app.notify('loupe', $next);
            });
          });
        },
        hide: function($el, callback){
          $el.velocity({ opacity: 0 }, {
            duration: 250,
            complete: function(){
              $el.hide();
              callback();
            }
          });
          // $el.hide();
        },
        show: function($el, callback){
          $el.velocity({ opacity: 1 }, {
            duration: 250,
            begin: function(){
              $el.show();
              if (callback) {
                callback();
              }
            }
          });
          // $el.show();
        },
        clearTimeout: function()
        {
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        },
        setTimeout: function() {
          var carousel = this;
          this.clearTimeout();
          this.timeout = setTimeout(function(){
            carousel.next();
          }, 10000);
        }
    },

    init: function(){
        this.Carousel2.prototype = this.Carousel2Prototype;
    },

    onLoad: function(){
        var carousel2s = $('.carousel2'), i = carousel2s.length;
        while (i--){
            new this.Carousel2(carousel2s[i]);
        }
    }
});













// WEBPACK FOOTER //
// ./resources/assets/js/modules/carousel2.js